export const map = {
    components: {
        deprecated: require('components/deprecated/deprecated.desktop'),
        videoTmp: require('components/video-tmp/video-tmp.desktop'),
        rotateDevice: require('components/rotate-device/rotate-device.desktop'),
        sliderBox: require('components/slider-box/slider-box.desktop'),
        latestNews: require('components/latest-news/latest-news.desktop'),
        historySlider: require('components/history-slider/history-slider.desktop'),
        relatedContent: require('components/related-content/related-content.desktop'),
        assets: require('components/assets/assets.desktop'),
        keyFigures: require('components/key-figures/key-figures.desktop'),
        contactBlock: require('components/contact-block/contact-block.desktop'),
        galleryOverlapped: require('components/gallery-overlapped/gallery-overlapped.desktop'),
        menu: require('components/menu/menu.desktop'),
        footer: require('components/footer/footer.desktop'),
        header: require('components/header/header.desktop'),
        select: require('components/select/select.desktop'),
        introduction: require('components/introduction/introduction.desktop'),
        slideshow: require('components/slideshow/slideshow.desktop'),
        sliderColumns: require('components/slider-columns/slider-columns.desktop'),
        socialNetworks: require('components/social-networks/social-networks.desktop'),
        video: require('components/video/video.desktop'),
        fullScreenBlock: require('components/fullscreen-block/fullscreen-block.desktop'),
        mapbox: require('components/mapbox/mapbox.desktop'),
        visualBlock: require('components/visual-block/visual-block.desktop'),
        collaboratorsGroups: require('components/collaborators-groups/collaborators-groups.desktop'),
        mosaic: require('components/mosaic/mosaic.desktop'),
        cards: require('components/cards/cards.desktop'),
    },
    pages: {
        homepage: {
            index: require('pages/homepage/homepage-index.desktop'),
            edge: require('pages/homepage/homepage-edge.desktop'),
        },
        cinemas: {
            index: require('pages/cinemas/cinemas.desktop')
        },
        pathe: {
            index: require('pages/pathe/pathe.desktop'),
            live: require('pages/pathe-live/pathe-live.desktop')
        },
        movies: {
            index: require('pages/movies/movies.desktop')
        },
        foundation: {
            index: require('pages/foundation/foundation.desktop')
        },
        // career: {
        //     index: require('pages/career/career.desktop')
        // },
        newsroom: {
            index: require('pages/newsroom/newsroom.desktop')
        },
        blogpost: {
            single: require('pages/single-blog-post/single-blog-post.desktop')
        },
        contact: {
            index: require('pages/contact/contact.desktop')
        },
        unsupported: {
            index: require('pages/browser-not-supported/browser-not-supported-index.desktop')
        },
        error: {
            index: require('pages/error/error-index.desktop')
        },
        legals: {
            index: require('pages/legals/legals-index.desktop')
        }
    }
};



// WEBPACK FOOTER //
// src/js/map/map.desktop.js